import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import FirearmLooseBarrelTypeForm from '../../../components/forms/FirearmLooseBarrelTypeForm';
import { useFirearmLooseBarrelTypeById, useUpdateFirearmLooseBarrelType } from '../../../hooks/useFirearmLooseBarrelTypeApi';
import { useNavigate, useParams } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { FirearmLooseBarrelTypeDTO } from '../../../services/apiClient';

const FirearmLooseBarrelTypeEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { data: entityData, isLoading } = useFirearmLooseBarrelTypeById(id!);
  const updateFirearmLooseBarrelType = useUpdateFirearmLooseBarrelType();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Firearm Loose Barrel Types', href: '/admin/firearmloosebarreltypes' },
    { label: 'Edit', href: '#' },
  ];

  const handleSubmit = async (data: any) => {
    try {
      setIsSubmitting(true);
      await updateFirearmLooseBarrelType.mutateAsync({ id: id!, data });
      navigate('/admin/firearmloosebarreltypes');
    } catch (error) {
      console.error('Error updating FirearmLooseBarrelType:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/firearmloosebarreltypes"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.FirearmLooseBarrelType.Edit'
    >
        {entityData ? (
          <FirearmLooseBarrelTypeForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/firearmloosebarreltypes')}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default FirearmLooseBarrelTypeEdit;